module.exports = __webpack_public_path__ + "img/in-love.4d31e333.png";